import Alpine from 'alpinejs';

Alpine.data('SchoolLogin', () => ({
  loading: false,
  errorCode: undefined,
  errorText: '',
  form: {
    code: '',
    password: '',
  },

  handleSubmit: async function (e: Event) {
    e.preventDefault();
    this.loading = true;
    this.errorText = '';
    this.errorCode = undefined;

    const redirect = this.$refs.form.getAttribute('data-redirect');

    try {
      const response = await fetch(`${window.location.origin}/apps/acidgreen/authenticate`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          username: this.form.code,
          password: this.form.password,
          returnUrl: redirect,
        }),
      });

      const json = await response.json();

      if (json && json.status === 'success') {
        if (json.url) {
          window.localStorage.setItem('force-school-region', 'true');
          location.href = json.url.replace('unsw-global.myshopify.com', 'shop.icasassessments.com');
        } else {
          this.errorText = json.message;
        }
      } else if (response.status == 422 && json.code == 'SHOPIFY_EMAIL_TAKEN') {
        // The template will show a div with text that can be configured in Shopify
        this.errorCode = json.code;
      } else {
        this.errorText = json?.message || response.statusText;
      }
      this.loading = false;
    } catch (e) {
      this.errorText = e?.message || 'An error occured. Please try again later.';
      this.loading = false;
    }
  },
}));
